import { render, staticRenderFns } from "./BetRankEntry.vue?vue&type=template&id=366df630&"
import script from "./BetRankEntry.vue?vue&type=script&lang=js&"
export * from "./BetRankEntry.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports